// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const Cooling = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    /*eslint-disable max-len */
    return (
        <G {...gProps}>
            <Path d="M20,36a.5.5,0,0,1-.5-.5V4.5a.5.5,0,0,1,1,0v31A.5.5,0,0,1,20,36Z" />
            <Path d="M20,10.61a.5.5,0,0,1-.22-.05L14.5,7.92A.5.5,0,0,1,14.95,7l5.28,2.64a.5.5,0,0,1-.22.95Z" />
            <Path d="M20,10.61a.5.5,0,0,1-.22-.95L25.05,7a.5.5,0,0,1,.45.89l-5.28,2.64A.5.5,0,0,1,20,10.61Z" />
            <Path d="M14.72,33a.5.5,0,0,1-.22-.95l5.28-2.64a.5.5,0,0,1,.45.89L14.95,33A.49.49,0,0,1,14.72,33Z" />
            <Path d="M25.28,33a.49.49,0,0,1-.22-.05l-5.28-2.64a.5.5,0,0,1,.45-.89l5.28,2.64a.5.5,0,0,1-.22.95Z" />
            <Path d="M7,28.94A.5.5,0,0,1,6.73,28l26-16.88a.5.5,0,1,1,.54.84l-26,16.88A.5.5,0,0,1,7,28.94Z" />
            <Path d="M28.3,15.11a.5.5,0,0,1-.5-.44l-.66-5.86a.5.5,0,1,1,1-.11l.66,5.86a.5.5,0,0,1-.44.55Z" />
            <Path d="M33.38,18.1a.5.5,0,0,1-.25-.07L28,15a.5.5,0,0,1,.51-.86l5.09,3a.5.5,0,0,1-.25.93Z" />
            <Path d="M11.7,25.89a.5.5,0,0,1-.25-.07l-5.09-3A.5.5,0,1,1,6.87,22L12,25a.5.5,0,0,1-.25.93Z" />
            <Path d="M12.36,31.75a.5.5,0,0,1-.5-.44l-.66-5.86a.5.5,0,1,1,1-.11l.66,5.86a.5.5,0,0,1-.44.55Z" />
            <Path d="M33,28.94a.5.5,0,0,1-.27-.08L6.73,12a.5.5,0,1,1,.54-.84L33.27,28a.5.5,0,0,1-.27.92Z" />
            <Path d="M6.62,18.1a.5.5,0,0,1-.25-.93l5.09-3A.5.5,0,0,1,12,15L6.87,18A.5.5,0,0,1,6.62,18.1Z" />
            <Path d="M11.7,15.11h-.06a.5.5,0,0,1-.44-.55l.66-5.86a.5.5,0,1,1,1,.11l-.66,5.86A.5.5,0,0,1,11.7,15.11Z" />
            <Path d="M27.64,31.75h-.06a.5.5,0,0,1-.44-.55l.66-5.86a.5.5,0,1,1,1,.11l-.66,5.86A.5.5,0,0,1,27.64,31.75Z" />
            <Path d="M28.3,25.89A.5.5,0,0,1,28,25l5.09-3a.5.5,0,1,1,.51.86l-5.09,3A.5.5,0,0,1,28.3,25.89Z" />
        </G>
    );
    /*eslint-enable max-len */
};

export default Cooling;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/devices/cooling/index.js